import { defineMessages } from 'react-intl';

export default defineMessages({
    accountSummary: {
        id: 'ac.portal.views.home-page-layout.Account Summary',
        defaultMessage: 'Account Summary',
    },
    mySummary: {
        id: 'ac.portal.views.home-page-layout.My Summary',
        defaultMessage: 'My Summary',
    },
    myBalance: {
        id: 'ac.portal.directives.templates.billing-summary-tiles.My Balance',
        defaultMessage: 'My Balance',
    },
    pastDue: {
        id: 'ac.portal.directives.templates.billing-summary-tiles.Past Due',
        defaultMessage: 'Past Due',
    },
    payNow: {
        id: 'ac.portal.directives.templates.billing-summary-tiles.Pay Now',
        defaultMessage: 'Pay Now',
    },
    myNextBill: {
        id: 'ac.portal.directives.templates.billing-summary-tiles.My Next Bill',
        defaultMessage: 'My Next Bill',
    },
    dueDate: {
        id: 'ac.portal.directives.templates.billing-summary-tiles.Due Date',
        defaultMessage: 'Due Date',
    },
    updateMyDetails: {
        id: 'ac.portal.views.home-page-layout.Update My Details',
        defaultMessage: 'Update My Details',
    },
    lastPayment: {
        id: 'ac.portal.directives.templates.billing-summary-tiles.My Last Payment',
        defaultMessage: 'My Last Payment',
    },
    paid: {
        id: 'ac.portal.directives.templates.billing-summary-tiles.Paid',
        defaultMessage: 'Paid',
    },
    renewalInfo: {
        id: 'ac.portal.views.home-page-layout.You have policies due for renewal.',
        defaultMessage: 'You have policies due for renewal.',
    },
    policies: {
        id: 'ac.portal.views.home-page-layout.Policies',
        defaultMessage: 'Policies',
    },
    account: {
        id: 'ac.policy.common.directives.templates.policy-account-policy-summaries.Account',
        defaultMessage: 'Account',
    },
    type: {
        id: 'ac.policy.common.directives.templates.policy-account-policy-summaries.Policy Type',
        defaultMessage: 'Policy Type',
    },
    statusActive: {
        id: 'ac.policy.common.directives.templates.policy-account-policy-summaries.Active',
        defaultMessage: 'Active',
    },
    statusRenewed: {
        id: 'ac.policy.common.directives.templates.policy-account-policy-summaries.Renewed',
        defaultMessage: 'Renewed',
    },
    status: {
        id: 'ac.policy.common.directives.templates.policy-account-policy-summaries.Policy Status',
        defaultMessage: 'Policy Status',
    },
    policy: {
        id: 'ac.policy.common.directives.templates.policy-account-policy-summaries.policy',
        defaultMessage: 'Policy',
    },
    effective: {
        id: 'ac.policy.common.directives.templates.policy-account-policy-summaries.effective',
        defaultMessage: 'Effective Period',
    },
    premium: {
        id: 'ac.policy.common.directives.templates.policy-account-policy-summaries.premium',
        defaultMessage: 'Premium',
    },
    myQuickLinks: {
        id: 'ac.portal.views.home-page-layout.My Quick Links',
        defaultMessage: 'My Quick Links',
    },
    printanIDCard: {
        id: 'ac.portal.views.home-page-layout.Print an ID Card',
        defaultMessage: 'Print an ID Card',
    },
    makeAPayment: {
        id: 'ac.portal.views.home-page-layout.Make a Payment',
        defaultMessage: 'Make a Payment',
    },
    setupAutomaticPayments: {
        id: 'ac.portal.views.home-page-layout.Setup Automatic Payments',
        defaultMessage: 'Setup Automatic Payments',
    },
    changeMyPolicy: {
        id: 'ac.portal.views.home-page-layout.ChangeMyPolicy',
        defaultMessage: 'Change My Policy',
    },
    fileClaim: {
        id: 'ac.portal.views.home-page-layout.FileClaim',
        defaultMessage: 'File a Claim',
    },
    getAPersonalAutoQuote: {
        id: 'ac.portal.views.home-page-layout.Get a Personal Auto Quote',
        defaultMessage: 'Get a Personal Auto Quote',
    },
    getAHomeOwnersQuote: {
        id: 'ac.portal.views.home-page-layout.Get a Home Owners Quote',
        defaultMessage: 'Get a Home Owners Quote',
    },
    offerDetailsAccount: {
        id: 'twia.policy.common.directives.templates.policy-account-offer-summaries.account',
        defaultMessage: 'Account',
    },
    offerDetailsPolicyType: {
        id: 'twia.policy.common.directives.templates.policy-account-offer-summaries.policyType',
        defaultMessage: 'Type',
    },
    offerDetailsOffer: {
        id: 'twia.policy.common.directives.templates.policy-account-offer-summaries.offer',
        defaultMessage: 'Offer',
    },
    offerDetailsEffective: {
        id: 'twia.policy.common.directives.templates.policy-account-offer-summaries.effective',
        defaultMessage: 'Effective',
    },
    offerDetailsPremium: {
        id: 'twia.policy.common.directives.templates.policy-account-offer-summaries.premium',
        defaultMessage: 'Premium',
    },
    offerDetailsReviewPay: {
        id: 'twia.policy.common.directives.templates.policy-account-offer-summaries.reviewPay',
        defaultMessage: 'Review & Pay',
    },
    offerDetailsReviewPayMobile: {
        id: 'twia.policy.common.directives.templates.policy-account-offer-summaries.Pay',
        defaultMessage: 'Pay',
    },
    policyDetailsAgent: {
        id: 'ac.policy.common.directives.templates.policy-account-policy-summaries.agent',
        defaultMessage: 'Agent',
    },
    policyDetailsTel: {
        id: 'ac.policy.common.directives.templates.policy-account-policy-summaries.tel',
        defaultMessage: 'T.',
    },
    policyDetailsIdCard: {
        id: 'ac.policy.common.directives.templates.policy-account-policy-summaries.id card',
        defaultMessage: 'ID Card',
    },
    policyDetailsFileClaim: {
        id: 'ac.policy.common.directives.templates.policy-account-policy-summaries.fileClaim',
        defaultMessage: 'File a Claim',
    },
    myBalanceTileCurrent: {
        id: 'ac.portal.directives.templates.billing-summary-tiles.Current',
        defaultMessage: 'Current',
    },
    policyNotShowing: {
        id: 'ac.portal.views.home-page-layout.Do you have a policy with us but it is not showing?',
        defaultMessage: 'Do you have a policy with us but it is not showing?',
    },
    addPolicy: {
        id: 'ac.portal.views.home-page-layout.Add Policy',
        defaultMessage: 'Add Policy',
    },
    renewalBannerText: {
        id: 'twia.policy.common.directives.templates.policy-account-offer-summaries.Renewals Due',
        defaultMessage: 'You have policies due for renewal listed in Available Offers below. If you can\'t access your offer, please contact your agent.',
    },
    availableOffers: {
        id: "twia.portal.views.home-page-layout.Available Offers",
        defaultMessage: "Available Offers"
    },
    offersNote:{
        id: "twia.portal.views.home-page-layout.Offers are not included in the balances above. Please see the Available Offers below.",
        defaultMessage: "*Offers are not included in the balances above. Please see the Available Offers below."
    },
    changePassword: {
        id: "twia.portal.views.home-page-layout.Change Password",
        defaultMessage: "Change Password"
    },
    confirmLogout: {
        id: "twia.portal.views.home-page-layout.You will be logged out and directed to our login screen to change your password.",
        defaultMessage: "You will be logged out and directed to our login screen to change your password."
    },
    welcomeNote: {
        id: 'twia.portal.views.home-page-layout.For information and support using your TWIA account please ',
        defaultMessage: 'For information and support using your TWIA account please '
    },
    welcomeNoteLink:{
        id: 'twia.portal.views.home-page-layout.visit our website',
        defaultMessage: 'visit our website'
    }
});
